import { render, staticRenderFns } from "./DistrubutiveUser.vue?vue&type=template&id=90f0550e&scoped=true&"
import script from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
export * from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
import style0 from "./DistrubutiveUser.vue?vue&type=style&index=0&id=90f0550e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f0550e",
  null
  
)

export default component.exports